import { MAX_SCORE, MIN_SCORE, PASS_SCORE } from "../data/exams";

/** So sánh đáp án theo tập hợp (không phụ thuộc thứ tự). */
export function isCorrect(selected: readonly number[], answer: readonly number[]): boolean {
  if (selected.length !== answer.length) return false;
  const set = new Set(answer);
  return selected.every((i) => set.has(i));
}

/**
 * Quy đổi tỉ lệ đúng sang thang 100–1000. Anthropic không công bố công thức scale,
 * nên đây là quy đổi tuyến tính để ƯỚC LƯỢNG — đạt (≥720) tương ứng ~69% câu đúng.
 */
export function scaledScore(correct: number, total: number): number {
  if (total <= 0) return MIN_SCORE;
  const ratio = Math.min(1, Math.max(0, correct / total));
  return Math.round(MIN_SCORE + ratio * (MAX_SCORE - MIN_SCORE));
}

export function isPass(scaled: number): boolean {
  return scaled >= PASS_SCORE;
}

/** Tỉ lệ đúng tối thiểu để đạt theo phép quy đổi tuyến tính ở trên. */
export const PASS_RATIO = (PASS_SCORE - MIN_SCORE) / (MAX_SCORE - MIN_SCORE);
